import { Quote as MarketistQuote } from '@doist/marketist'

import { addProtocol } from 'app/services/contentful/add-protocol-to-url'

import { type QuoteProps } from '../types'

function Quote({ fields: { text, author, role, avatar } }: QuoteProps) {
    const avatarSrc = avatar?.fields?.file ? addProtocol(avatar.fields.file.url) : undefined

    return (
        <MarketistQuote
            quoteText={text}
            author={author}
            role={role}
            avatarSrc={avatarSrc}
            className="mbe-96 md-mbe-192 md-mbs-192 mbs-96"
        />
    )
}

export { Quote }
